import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  signal
} from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { indicateLoading } from '@core/helpers';
import { Notifier } from '@core/notifications';

import { PromocodesState } from '../../promocodes.state';

const PROFILE_CHECKED_MESSAGE = $localize`:@@bonuses.conditions_refreshed:Профиль перепроверен!`;

@Component({
    selector: 'promocodes-user-conditions',
    imports: [],
    templateUrl: './user-conditions.dialog.html',
    styleUrl: './user-conditions.dialog.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserConditionsDialog {
  public readonly promocodesState = inject(PromocodesState);

  public readonly dialogRef = inject(DialogRef);
  private readonly destroyRef = inject(DestroyRef);
  private readonly notifier = inject(Notifier);

  public readonly isRechecking = signal<boolean>(false);
  public readonly isLoading = signal<boolean>(false);

  recheckConditions(): void {
    this.promocodesState.recheckConditions()
      .pipe(
        indicateLoading(this.isRechecking),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.notifier.success(PROFILE_CHECKED_MESSAGE);
      });
  }
}
